import { render, staticRenderFns } from "./OiltankManageAdd.vue?vue&type=template&id=86397742&scoped=true"
import script from "./OiltankManageAdd.vue?vue&type=script&lang=js"
export * from "./OiltankManageAdd.vue?vue&type=script&lang=js"
import style0 from "./OiltankManageAdd.vue?vue&type=style&index=0&id=86397742&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86397742",
  null
  
)

export default component.exports